import {
  DeserializedRecord,
  deserializeItem,
  Deserializer,
  deserializeSingleRelationship,
  JSONAPIRecord,
  JSONAPISingleRelationship
} from "../../Helpers";
import {MeasurementKey} from "vendor/qurasoft/definitions/types/measurements";
import {deserializeMeasurement, Measurement} from "../../patient/Measurement";
import {deserializeMeasurementTrigger, deserializePatientTrigger, MeasurementTrigger, PatientTrigger} from "../../Trigger";
import {deserializePatientTriggerEvent, PatientTriggerEvent} from "../PatientTriggerEvent";

type EventType = 'measurement' | 'control_alarm';

interface Event extends DeserializedRecord {
  eventType: EventType;
  patientTriggerValueType: MeasurementKey;
  phone: string;
  patientMeasurement: Measurement,
  patientMeasurementTrigger: MeasurementTrigger,
  patientTrigger: PatientTrigger,
  patientTriggerEvent: PatientTriggerEvent,
}

interface EventData extends JSONAPIRecord {
  relationships: {
    patient_measurement: JSONAPISingleRelationship,
    patient_measurement_trigger: JSONAPISingleRelationship,
    patient_trigger: JSONAPISingleRelationship,
    patient_trigger_event: JSONAPISingleRelationship
  }
}

const deserializePatientMeasurementTriggerEvent: Deserializer<Event, EventData> = (data, included) => {
  const patientMeasurement = deserializeSingleRelationship<Measurement>(data.relationships.patient_measurement, included, deserializeMeasurement);
  const patientTrigger = deserializeSingleRelationship<PatientTrigger>(data.relationships.patient_trigger, included, deserializePatientTrigger);
  // eslint-disable-next-line @stylistic/max-len
  const patientTriggerEvent = deserializeSingleRelationship<PatientTriggerEvent>(data.relationships.patient_trigger_event, included, deserializePatientTriggerEvent);

  const patientMeasurementTrigger = deserializeSingleRelationship<MeasurementTrigger>(
    data.relationships.patient_measurement_trigger, included, deserializeMeasurementTrigger);

  return {
    ...deserializeItem(data),
    patientMeasurement,
    patientTrigger,
    patientTriggerEvent,
    patientMeasurementTrigger
  };
};

const deserializePatientMeasurementTriggerEventWithoutTriggerEvent: Deserializer<Event, EventData> = (data, included) => {
  const patientMeasurement = deserializeSingleRelationship<Measurement>(data.relationships.patient_measurement, included, deserializeMeasurement);
  const patientTrigger = deserializeSingleRelationship<PatientTrigger>(data.relationships.patient_trigger, included, deserializePatientTrigger);

  return {
    ...deserializeItem(data),
    patientMeasurement,
    patientTrigger
  };
};

export {
  Event, deserializePatientMeasurementTriggerEvent, deserializePatientMeasurementTriggerEventWithoutTriggerEvent
};
